export default __webpack_public_path__ + "static/media/summerchallenge05.1f7aa224.jpg";